import cx from 'classnames';
import {isProOrPartyPassUser} from '~/CreateFabricInvitation/utils/experiments';
import {Button} from '~library/atoms/Button';
import {Typography} from '~library/atoms/Typography';
import {useIsMediumAndUp} from '~library/hooks/useMatchQuery';
import {DiamondFillIcon} from '~library/svg/DiamondFillIcon';
import {ProLogoMobileIcon} from '~library/svg/v2/ProLogoMobileIcon';

import {premiumColor} from '~libSass/base/_exports.sass';

export const NamedStepsNav = ({
  isPremium,
  stepsToShow,
  filteredEventSteps,
  unlockedSteps,
  currentRoute,
  preClickHandler,
}) => {
  const isMediumAndUp = useIsMediumAndUp();
  const isEditGuests = currentRoute.meta.editing && currentRoute.name === 'guests';
  const isCheckoutStep = currentRoute.name === 'review';
  const showProLogo = isProOrPartyPassUser(window?.subscriptionPlanName);

  return (
    <div
      className={cx('named-steps-nav__steps', {
        'named-steps-nav__steps--premium': isPremium,
        'named-steps-nav__steps--pro': showProLogo,
      })}
    >
      {!isMediumAndUp && (isPremium || showProLogo) && !isCheckoutStep ? (
        <div
          className={cx({
            'named-steps-nav__premium--mw': isPremium,
            'named-steps-nav__pro--mw': showProLogo,
          })}
        >
          {showProLogo ? (
            <ProLogoMobileIcon />
          ) : (
            <DiamondFillIcon color={premiumColor} ratio={0.3125} />
          )}
        </div>
      ) : null}

      {isEditGuests || isCheckoutStep ? (
        <Typography
          variant={isMediumAndUp ? 'header5' : 'header7'}
          as="h1"
          className="named-steps-nav__title"
        >
          {currentRoute.displayName}
        </Typography>
      ) : (
        stepsToShow.map((step) => {
          const stepData = filteredEventSteps[step];
          const isActiveStep = currentRoute.name === step;

          if (isActiveStep) {
            return (
              <Typography
                variant={isMediumAndUp ? 'paragraph2' : 'paragraph3'}
                as="span"
                className="named-steps-nav__step--active"
                key={`active-${stepData.id}`}
                id={`${step}-step`}
              >
                {stepData.displayName.charAt(0).toUpperCase() + stepData.displayName.slice(1)}
                <span
                  className={cx('named-steps-nav__step-underline', {
                    'named-steps-nav__step-underline--active': isActiveStep,
                  })}
                ></span>
              </Typography>
            );
          }

          return (
            <Button
              key={stepData.id}
              id={`${step}-step`}
              variant="tertiary"
              size={isMediumAndUp ? 'medium' : 'small'}
              data-qa-id={`${step}-step`}
              disableProcessing
              className="named-steps-nav__step"
              onClick={() => preClickHandler(step)}
              disabled={!unlockedSteps.includes(step) && !isActiveStep}
            >
              {stepData.displayName.charAt(0).toUpperCase() + stepData.displayName.slice(1)}
            </Button>
          );
        })
      )}
    </div>
  );
};
